import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastSuccess,
  ToastError,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useDroneAreasContext } from 'src/contexts/drone-areas.context';
import { actionTypes } from 'src/ducks/drone-areas.duck';
import { IDroneAreas, IDroneAreasForm } from 'src/models/drone-areas.model';
import { getDroneAreasStatus } from 'src/selectors/drone-areas.selector';
import style from '../drone-areas-list/drone-areas-list.module.scss';
import DroneAreasForm from '../drone-areas-form/drone-areas-form.component';

type IProp = {
  data: IDroneAreas;
};

const DroneAreasEdit: React.FC<IProp> = ({ data }) => {
  const { state, actions } = useDroneAreasContext();
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(true);
  const formRef = useRef<HTMLFormElement>(null);

  let defaultValues: Partial<IDroneAreas> = {
    SensitiveCityLocation: '',
  };

  if (data) {
    defaultValues = data;
  }

  const editStatus = getDroneAreasStatus(state, actionTypes.DRONE_AREAS_UPDATE);

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (value) => {
      const formData: IDroneAreasForm = {
        SensitiveCityLocation: value.SensitiveCityLocation,
      };
      const response = await actions.updatePUT(value.droneAreasId, formData);
      if (!response.error) {
        ToastSuccess(
          Lang.formatString(
            Lang.MSG_DRONE_AREAS_EDIT_SUCCESS,
            formData.SensitiveCityLocation ? formData.SensitiveCityLocation : value.SensitiveCityLocation
          )
        );
      } else {
        ToastError(response.error.message);
      }
      setIsEditOpen(false);
      actions.listGET();
    },
    [actions, setIsEditOpen]
  );

  return (
    <ATMModal
      open={isEditOpen}
      size="tiny"
      trigger={
        <ATMButton
          className={style.actionIcon}
          basic
          icon="edit outline"
          onClick={() => setIsEditOpen(true)}
        />
      }
      header={Lang.LBL_EDIT_DRONE_AREAS}
      content={
        <div className={style.content}>
          <DroneAreasForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsEditOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || editStatus.fetching}
            onClick={handleSave}
            loading={editStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default DroneAreasEdit;
